import { useStaticQuery, graphql } from "gatsby"

export const QueryImage = () => {
    const { allFile } = useStaticQuery(
    graphql`
      query {
        allFile(filter: {extension: {regex: "/(jpg)|(jpeg)|(png)/"}, relativeDirectory: {eq: "virbac"}}, sort: {fields: name}) {
          edges {
            node {
              childImageSharp {
                fluid(quality: 90) {
                  aspectRatio
                    base64
                    sizes
                    src
                    srcSet
                  }
              }
            }
          }
        }
      }
    `
    )
    return allFile
}